import {createContext, useContext} from 'react';

/*
 * Types.
 */

export interface DataFieldsTableSearchValue {
  publicId: string;
  searchValue: string;
}

export interface DataFieldsTableSearchContextData {
  addSearchData: (resources: ReadonlyArray<DataFieldsTableSearchValue>) => void;
}

/*
 * Context.
 */

export const DataFieldsTableSearchContext = createContext<DataFieldsTableSearchContextData>({
  addSearchData: () => {},
});
export function useDataFieldsTableSearchContext() {
  return useContext(DataFieldsTableSearchContext);
}
